module.exports = __webpack_public_path__ + "896f5819064bc6f65626c9228931fa24.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/book_2.png
// module id = 299
// module chunks = 0